import {
	DetectionAngleSpecification,
	DetectionAreaSpecification,
	DetectionBrandSpecification,
	DetectionLogoOrTextSpecification,
	DetectionPlacementSpecification,
	DetectionPositionSpecification,
	DetectionTimeSpecification,
	DetectionPerspectiveSpecification,
	DetectionConfidenceSpecification,
} from 'Models/Project/ProjectFilterSpecifications';

export interface DetectionFilterCriteria {
	angle: DetectionAngleSpecification | null;
	area: DetectionAreaSpecification | null;
	brand: DetectionBrandSpecification | null;
	logoOrText: DetectionLogoOrTextSpecification | null;
	placement: DetectionPlacementSpecification | null;
	position: DetectionPositionSpecification | null;
	time: DetectionTimeSpecification | null;
	perspective: DetectionPerspectiveSpecification | null;
	confidence: DetectionConfidenceSpecification | null;
}

export const emptyDetectionFilterCriteria: DetectionFilterCriteria = {
	angle: null,
	area: null,
	brand: null,
	logoOrText: null,
	placement: null,
	position: null,
	time: null,
	perspective: null,
	confidence: null,
};
